const calls = {
  async get_gameformat_groups({ dispatch }, groups) {
    return dispatch('api_call', {
      endpoint: `game-modes/`,
      hasCancel: false,
      params: {
        format_in: groups,
      },
      action: 'gameformat_set_gameformat',
      actionArgs: { groups },
      apiVersion: 'v4',
    })
  },
}

export default calls
